<div class="appo-appointment-request-page content-desktop">
  <div class="pasi-card">
    <si-pasi-wizard *ngIf="!finishError && !finish && !displayLinkPatientPage" [steps]="steps" [currentStep]="currentStep">
      <div [ngSwitch]="steps[currentStep].key">
        <ng-container *ngSwitchCase="stepKeys.REQUIREMENTS">
          <si-appo-appointment-request-requirements [(model)]="model"
                                                    [readMode]="stepOneReadMode"
                                                    [(form)]="form"
                                                    [formId]="appoAppointmentRequestRequirementsFormId"
                                                    [externalScheduleParamFlag]="true"
          ></si-appo-appointment-request-requirements>
        </ng-container>
        <ng-container *ngSwitchCase="stepKeys.DATE_AND_TIME">
          <si-appo-appointment-request-date [(model)]="model"
                                            [(form)]="form"
                                            [formId]="appoAppointmentRequestDateFormId"
                                            [(currentStep)]="currentStep"
                                            [(slotsUpdate)]="slotsUpdate"
          ></si-appo-appointment-request-date>
        </ng-container>
        <ng-container *ngSwitchCase="stepKeys.IDENTIFICATION">
          <si-appo-appointment-request-identification [(model)]="model"
                                                      [(form)]="form"
                                                      [formId]="appoAppointmentRequestIdentificationFormId"
                                                      [passwordErrorText]="passwordErrorText"
                                                      [validationErrorTextIdentityDocument]="validationErrorTextIdentityDocument"
                                                      (loginSuccessChange)="onLoginSuccessChange()"
                                                      (captchaRenderedChange)="onChangeCaptchaRendered($event)"
          ></si-appo-appointment-request-identification>
        </ng-container>
        <ng-container *ngSwitchCase="stepKeys.CONFIRMATION">
          <si-appo-appointment-request-confirm-date [(model)]="model"
                                                    [(form)]="form"
                                                    [formId]="appoAppointmentRequestConfirmFormId"
                                                    [(currentStep)]="currentStep"
                                                    [collectiveWarningCheck]="collectiveWarningCheck"
                                                    [(finish)]="finish"
                                                    [(textError)]="textError"
                                                    [(finishError)]="finishError"
                                                    [(slotConfirmation)]="slotConfirmation"
                                                    [(slotReservationDelete)]="slotReservationDelete"
          ></si-appo-appointment-request-confirm-date>
        </ng-container>
        <ng-container *ngSwitchDefault>
        </ng-container>
      </div>
      <div class="container-fluid px-0 mt-4">
        <div class="row no-gutters">
          <div *ngIf="currentStep < steps.length - 1"
                class="col-12 col-sm-auto mb-3 mb-sm-0 pr-sm-1 pl-sm-1">
            <button class="si-button_main w-100"
                    translate="SI_NEXT"
                    type="button"
                    (click)="onClickContinue()"
                    [disabled]="form?.invalid || (captchaRendered && !model.captchaResponse?.captchaKey)"
            ></button>
          </div>
          <div *ngIf="currentStep === steps.length - 1"
                class="col-12 col-sm-auto mb-3 mb-sm-0 pr-sm-1 pl-sm-1">
            <button class="si-button_main w-100"
                    translate="SI_CONFIRM"
                    type="submit"
                    [attr.form]="appoAppointmentRequestConfirmFormId"
                    (click)="onClickFinish()"
                    [disabled]="form?.invalid"
            ></button>
          </div>
          <div *ngIf="currentStep > 0" class="col-12 col-sm-auto mb-3 mb-sm-0 pr-sm-1 order-sm-first">
            <button class="si-button_secondary w-100"
                    translate="SI_PREVIOUS"
                    type="button"
                    (click)="onClickPrevious()"
            ></button>
          </div>
          <div *siExternalReference="false" class="col-12 col-sm-auto pl-sm-1">
            <si-go-to-route-button text="SI_CANCEL"
                                   [href]="['/login']"
                                   styleClass="si-button_cancel w-100"
            ></si-go-to-route-button>
          </div>
        </div>
      </div>
    </si-pasi-wizard>
    <div *ngIf="finish">
      <si-appo-appointment-request-finish [(model)]="model"></si-appo-appointment-request-finish>
    </div>
    <div *ngIf="displayLinkPatientPage">
      <si-link-patient-page [(displayLinkPatientPage)]="displayLinkPatientPage"
                            [isPage]="false"
                            [(refreshUserRole)]="model.refreshUserRole"
                            (linkPatientSuccessChange)="onFinishNhcHealthCardVerification()"
      ></si-link-patient-page>
    </div>
    <ng-container *ngIf="hasSmsVerification || hasEmailVerification">
      <si-verification-parent [linkPatientVerification]="linkPatientVerification"
                              [(refreshUserRole)]="model.refreshUserRole"
                              (linkPatientSuccessChange)="onFinishDoubleFactorVerification()"
      ></si-verification-parent>
    </ng-container>
    <div *ngIf="finishError">
      <si-appo-appointment-request-finish-error [model]="model"
                                                [textError]="textError"
                                                [(finishError)]="finishError"
                                                [(currentStep)]="currentStep"
      ></si-appo-appointment-request-finish-error>
    </div>
    <ng-container *ngIf="displayExistingAccountDialog">
      <si-generic-dialog [(displayDialog)]="displayExistingAccountDialog"
                         dialogTitle="SI_MATCH_FOUND"
                         dialogText="SI_EXISTING_ACCOUNT_TEXT"
                         button1Text="SI_COMPLETE_DATA"
                         button1Class="si-button_main"
                         [button2Text]="(null | siExternalReference) ? '' : 'SI_REQUEST_BE_PHONED'"
                         button2Class="si-button_secondary"
                         button2Href="/request/phoned"
                         [button3Text]="(null | siExternalReference) ? '' : 'SI_APPOINTMENT_CANCEL'"
                         button3Class="si-button_cancel"
                         button3Href="/"
                         (updateButton1Change)="onUpdateExistingAccountDialogChange()"
      ></si-generic-dialog>
    </ng-container>
    <ng-container *ngIf="!isRegistered">
      <ng-container *ngIf="displayLogExistingAccountDialog">
        <si-generic-dialog [(displayDialog)]="displayLogExistingAccountDialog"
                           dialogTitle="SI_ACCOUNT_ALREADY_EXISTS"
                           dialogTitleStyleClass="mb-3"
                           dialogText="SI_LOGIN_IN_ALREADY_HAVE_ACCOUNT"
        ></si-generic-dialog>
      </ng-container>
      <ng-container *ngIf="displayLogRegisterFailDialog">
        <si-generic-dialog [(displayDialog)]="displayLogRegisterFailDialog"
                           dialogTitle="SI_FAIL_IN_REGISTER"
                           dialogImg="assets/images/user_not_found.svg"
                           [dialogText]="registerFailText"
                           button1Text="SI_CLOSE"
                           button1Class="si-button_secondary"
                           [closable]="false"
        ></si-generic-dialog>
      </ng-container>
      <ng-container *ngIf="displayLogRegisterLinkQuestionDialog">
        <si-generic-dialog [(displayDialog)]="displayLogRegisterLinkQuestionDialog"
                           dialogTitle="SI_NO_MATCHES"
                           dialogImg="assets/images/user_not_found.svg"
                           [dialogText]="registerLinkQuestionText"
                           button1Text="SI_CHECK_DATA"
                           button1Class="si-button_main"
                           button2Text="SI_FINISH_REGISTRATION"
                           button2Class="si-button_secondary"
                           [isScrollable]="true"
                           (updateButton2Change)="onClickEndRegistrationLinkQuestion()"
        ></si-generic-dialog>
      </ng-container>
      <ng-container *ngIf="hasSmsVerification && displayVerificationDialog">
        <si-sms-verification-dialog [(displayDialog)]="displayVerificationDialog"
                                    (displayDialogChange)="onChangeDisplayVerificationDialog($event)"
                                    [phoneValue]="model.phone?.value"
                                    [(smsVerificationCode)]="model.verificationCode"
                                    (smsVerificationCodeChange)="onChangeVerificationCode()"
                                    [smsVerificationErrorText]="verificationErrorText"
        ></si-sms-verification-dialog>
      </ng-container>
      <ng-container *ngIf="hasEmailVerification && displayVerificationDialog">
        <si-email-verification-dialog [(displayDialog)]="displayVerificationDialog"
                                      (displayDialogChange)="onChangeDisplayVerificationDialog($event)"
                                      [emailValue]="model.email"
                                      [(emailVerificationCode)]="model.verificationCode"
                                      (emailVerificationCodeChange)="onChangeVerificationCode()"
                                      [emailVerificationErrorText]="verificationErrorText"
        ></si-email-verification-dialog>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="displayResendVerifyEmailDialog">
      <si-generic-dialog [(displayDialog)]="displayResendVerifyEmailDialog"
                         dialogTitle="SI_RESEND_VERIFY_EMAIL_TITLE"
                         dialogText="SI_RESEND_VERIFY_EMAIL_INFO"
                         button1Text="SI_ACCEPT"
                         button1Class="si-button_main"
                         button2Text="SI_CANCEL"
                         button2Class="si-button_secondary"
                         [closable]="false"
                         (updateButton1Change)="onClickButtonResendVerifyEmailDialog(true)"
                         (updateButton2Change)="onClickButtonResendVerifyEmailDialog(false)">
      </si-generic-dialog>
    </ng-container>
  </div>
</div>
